import { EnvironmentUrls } from 'Roblox';
import { httpService } from 'core-utilities';

const { universalAppConfigurationApi } = EnvironmentUrls;

export type TDecomposedVPCStatusResponse = {
  data: {
    decomposedVPCEnabled: boolean;
  };
};

const universalAppConfigService = {
  getVPCStatus: async (): Promise<boolean> => {
    const res = (await httpService.get({
      url: `${universalAppConfigurationApi}/v1/behaviors/decomposed-vpc-status/content`,
      withCredentials: true
    })) as TDecomposedVPCStatusResponse;
    return res.data.decomposedVPCEnabled;
  }
};

export default universalAppConfigService;
